import React from "react";
import { Link } from "react-router-dom";

import EventNavigation from "../EventNavigation/EventNavigation";
import Form from "../Form/Form";
import Footer from "../Footer/Footer";
import firstEditionCover from "../../../assets/1 (1).png";
import secondEditionCover from "../../../assets/2 (1).png";
import "./proptech_times_page.css";

const magazineIssues = [
  {
    issue: "Issue 01",
    title: "Innovating real Estate Through Technology",
    date: "October 2024",
    pdf: "/the-proptech-times-1st-edition.pdf",
    cover: firstEditionCover,
  },
  {
    issue: "Issue 02",
    title: "Karachi Real Estate Outlook 2026",
    date: "April 2026",
    pdf: "/the-proptech-times-2nd-edition.pdf",
    cover: secondEditionCover,
  },
];

const PropTechTimesPage = () => {
  const handleSubscribeClick = () => {
    const formSection = document.getElementById("form_section");

    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <EventNavigation />

      <main id="proptech_times_page_main">
        <section id="proptech_times_intro">
          <div id="proptech_times_intro_inner">
            <p id="proptech_times_intro_eyebrow">The PropTech Times</p>
            <h1 id="proptech_times_intro_hdng">The stories, signals, and shifts shaping property technology.</h1>
            <p id="proptech_times_intro_txt">
              A dedicated space for updates, market intelligence, community highlights, and the conversations
              moving the PropTech ecosystem forward.
            </p>
            <div id="proptech_times_intro_actions">
              <button
                id="proptech_times_intro_btn_primary"
                type="button"
                onClick={handleSubscribeClick}
              >
                Subscribe Newsletter
              </button>
              <Link to="/membership" id="proptech_times_intro_btn_secondary">
                Become A Member
              </Link>
            </div>
          </div>
        </section>

        <section id="proptech_times_magazines">
          <div id="proptech_times_magazines_inner">
            {/* <div id="proptech_times_magazines_copy">
              <p id="proptech_times_magazines_eyebrow">Magazine Archive</p>
              <h2 id="proptech_times_magazines_hdng">Featured editions from PropTech Times.</h2>
              <p id="proptech_times_magazines_txt">
                A curated library of stories, interviews, market shifts, and ecosystem intelligence from
                across the built world.
              </p>
            </div> */}

            <div id="proptech_times_magazines_grid">
              {magazineIssues.map((magazine) => (
                <a
                  className="proptech_times_magazine_card"
                  key={magazine.issue}
                  href={magazine.pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Open ${magazine.title} preview in a new tab`}
                >
                  <div className="proptech_times_magazine_cover">
                    <img
                      className="proptech_times_magazine_image"
                      src={magazine.cover}
                      alt={`${magazine.title} cover`}
                    />
                  </div>
                  <div className="proptech_times_magazine_body">
                    <span className="proptech_times_magazine_issue">{magazine.issue}</span>
                    <h3 className="proptech_times_magazine_title">{magazine.title}</h3>
                    <p className="proptech_times_magazine_date">{magazine.date}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        <Form />
      </main>

      <Footer />
    </>
  );
};

export default PropTechTimesPage;
